const alertCookieName = 'alert-box';

function getCookie(name) {
  return document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`))?.split('=')[1];
}

export function initializeAlertRibbon() {
  const alert = document.querySelector('#global_alert');
  const closeButton = alert?.querySelector('#close');
  if (!alert || !closeButton) return;

  if (getCookie(alertCookieName) === 'closed') {
    alert.hidden = true;
    return;
  }

  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.cookie = `${alertCookieName}=closed; path=/; max-age=31536000; samesite=lax`;
    closeButton.disabled = true;

    const hideAlert = () => {
      alert.hidden = true;
    };

    alert.addEventListener('transitionend', hideAlert, { once: true });
    alert.style.height = `${alert.offsetHeight}px`;
    alert.getBoundingClientRect();
    alert.classList.add('is-closing');
    alert.style.height = '0px';
    window.setTimeout(hideAlert, 350);
  });
}
